module.exports = __webpack_public_path__ + "img/ticket.56221af1.svg";